<section class="contact-top">
        
            <div class="inner_sec">
                <div class="container">
                   <h2>Raw Materials.</h2>
                </div>

            <div class="tabbing_sec">
                <div class="product_list">

                    <div class="product_box">
                         <div class="container"> 
                           <h3>Resin</h3>
                           <div class="row">   
                            <div class="col-sm-4" *ngFor="let data of resign">
                                <div class="productItem">
                                    <figure> <img class="about-img" [src]="data.img" alt=""> </figure>
                                    <h4>{{data.title}}</h4>
                                    <p>{{data.description}}</p>
                                </div>
                            </div>
                           </div>
                         </div>
                     </div>

                     <div class="product_box gray">
                        <div class="container"> 
                          <div class="row">   
                           <div class="col-sm-4" *ngFor="let data of productlist">
                               <div class="productItem">
                                   <h4>{{data.title}}</h4>
                                   <figure> <img class="about-img" [src]="data.img" alt=""> </figure>
                                   <h5>{{data.subheading}}</h5> 
                                   <p>{{data.description}}</p>
                               </div>
                           </div>
                          </div>
                        </div>
                    </div>


                    <div class="product_box">
                        <div class="container"> 
                          <div class="row">   
                           <div class="col-sm-4" *ngFor="let data of productlistone">
                               <div class="productItem">
                                   <h4>{{data.title}}</h4>
                                   <figure> <img class="about-img" [src]="data.img" alt=""> </figure>
                                   <h5>{{data.subheading}}</h5> 
                                   <p>{{data.description}}</p>
                               </div>
                           </div>
                          </div>
                        </div>
                    </div>


                 </div>

                  
            </div>

            </div>

        
        
    
</section>
